import { MatPaginator } from '@angular/material/paginator';
import { Component, ViewChild, Input, NgModule, OnInit, Output, EventEmitter } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ComentarioFormComponent } from './comentario-form.component';
import { Comentario } from 'src/app/models/comentario.model';
import { Justificativa } from 'src/app/models/justificativa.model';
import { ComentarioService } from 'src/app/services/comentario.service';
import { JustificavaService } from 'src/app/services/justificativa.service';
import { Estimativa } from 'src/app/models/estimativa.model';
import { EstimativaService } from 'src/app/services/estimativa.service';
import { UtilService } from 'src/app/services/util.service';
import { Usuario } from 'src/app/models/usuario.model';
import * as constants from 'src/app/models/constants/constants';
import { ToastrComponent } from '../util/toastr/toastr.component';
import { Misc } from "../util/misc";

@Component({
  selector: 'app-comentario-list-component',
  styleUrls: ['comentario-list.component.scss'],
  templateUrl: 'comentario-list.component.html',
})

export class ComentarioListComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  @Input() estimativaId: number;
  @Input() somenteLeitura: boolean;
  @Input() verOriginal: true;
  @Output() existeComentario = new EventEmitter<boolean>();
  @Input() hiddenResume: boolean;

  comentarios: Comentario[] = [];
  displayedColumns: string[] = ['delete', 'edit', 'data', 'mensagem', 'usuario'];
  dataSource = new MatTableDataSource<Comentario>();
  justificativa: Justificativa = null;
  estimativa: Estimativa;
  loading = true;
  estimativaTipo: number;
  tipoDelivery: boolean;
  isBodyShop: boolean;

  constructor(
    private comentarioService: ComentarioService,
    private justificativaService: JustificavaService,
    private estimativaService: EstimativaService,
    private utilService: UtilService,
    private dialog: MatDialog,
    private router: Router,
    private toastr: ToastrComponent,
    public misc: Misc
  ) {
  }

  ngOnInit() {

    const perfilLogado = JSON.parse(localStorage.getItem('currentUserPricingWeb'));
    const perfilTipo = perfilLogado.perfil[0].id;

    if (perfilTipo == constants.PerfilConstants.ID_PERFIL_DELIVERY) {
      this.isBodyShop = false;
    }

    this.estimativaService.getEstimativaTipo(this.estimativaId).subscribe((result: any) => {

      this.estimativaTipo = result.estimativaTipoId

      if (this.estimativaTipo == 3) {
        this.somenteLeitura = false;
        this.tipoDelivery = true;
        this.hiddenResume;
      }

      this.estimativaService.getById(this.estimativaId).subscribe((estimativa: any) => {
        if (estimativa.statusId === constants.EstimativaStatusConstants.ID_ESTIMATIVA_APROVADA) {
          this.somenteLeitura = true;
        }
      });

      this.carregar();
    })

  }

  carregar() {
    this.comentarioService.getByEstimativaId(this.estimativaId).subscribe(comentarios => {
      this.comentarios = comentarios.items;
      this.dataSource = new MatTableDataSource<Comentario>(this.comentarios);
      this.dataSource.paginator = this.paginator;
      this.justificativaService.getByEstimativaId(this.estimativaId).subscribe(justificativa => {
        if (justificativa.items) {
          this.justificativa = justificativa.items[0];
          this.estimativaService.getById(this.estimativaId).subscribe(estimativa => {
            this.estimativa = estimativa;
            this.loading = false;
          });
        } else {
          this.loading = false;
        }
      });

      this.existeComentario.emit(comentarios.items.length > 0);
    });
  }

  abrirEstimativaOriginal() {
    switch (this.estimativa.estimativaTipoId) {
      case 1:
        this.router.navigate(['price/projeto/estimativa-resumo/' + this.justificativa.estimativaOriginalId]);
        break;
      default:
        this.router.navigate(['price/projeto/estimativa-edit/' + this.justificativa.estimativaOriginalId]).then(() => {
          window.location.reload();
        });
        break;
    }

  }

  adicionarComentario() {
    this.loading = true;

    const dialogRef = this.dialog.open(ComentarioFormComponent, {
      width: '600px',
      data: { estimativaId: this.estimativaId },
      panelClass: 'default-dialog-container'
    });

    dialogRef.afterClosed().subscribe((result: Comentario) => {
      if (result) {
        result.usuario = new Usuario();
        result.usuario.login = this.utilService.getUser().userName;

        this.comentarios.unshift(result);

        this.dataSource = new MatTableDataSource(this.comentarios);
      }

      this.loading = false;
    });
  }

  atualizarComentario(element: Comentario) {
    this.loading = true;

    if (this.estimativa.statusId == constants.EstimativaStatusConstants.ID_ESTIMATIVA_APROVADA) {
      this.toastr.mostrarMensagem('aviso', 'Aviso', 'Status da estimativa não permite atualização do comentário');
      this.loading = false;
    } else {
      const dialogRef = this.dialog.open(ComentarioFormComponent, {
        width: '600px',
        panelClass: 'default-dialog-container',
        data: {
          id: element.id,
          estimativaId: element.estimativaId,
          mensagem: element.mensagem
        }
      });

      dialogRef.afterClosed().subscribe((result: Comentario) => {
        this.carregar();

        this.loading = false;
      });
    }
  }

  excluirComentario(comentarioId) {
    this.loading = true;

    if (this.estimativa.statusId == constants.EstimativaStatusConstants.ID_ESTIMATIVA_APROVADA) {
      this.toastr.mostrarMensagem('aviso', 'Aviso', 'Status da estimativa não permite exclusão do comentário');
      this.loading = false;
    } else {
      this.comentarioService.desativarComentarioByComentarioId(comentarioId).subscribe(
        () => {
          this.carregar();
          this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Comentário excluído com sucesso');
          this.loading = false;
        },
        (error) => {
          this.misc.processError(error, "Não foi possível excluir o Comentário.");
          this.loading = false;
        }
      );
    }
  }
}
